(() => {
  const mqMobile = window.matchMedia('(hover: none) and (pointer: coarse)');

  function closeAll(except = null) {
    document.querySelectorAll('[data-pv-social].is-open').forEach((el) => {
      if (except && el === except) return;
      el.classList.remove('is-open');
    });
  }

  function init() {
    document.querySelectorAll('[data-pv-social]').forEach((wrap) => {
      if (wrap.dataset.pvBound === '1') return;
      wrap.dataset.pvBound = '1';

      const tapBtn = wrap.querySelector('.pv-social-hover-btn__tap');
      if (!tapBtn) return;

      tapBtn.addEventListener('click', (e) => {
        if (!mqMobile.matches) return; // desktop: no hace nada
        e.preventDefault();
        e.stopPropagation();

        const willOpen = !wrap.classList.contains('is-open');
        closeAll(wrap);
        if (willOpen) wrap.classList.add('is-open');
        else wrap.classList.remove('is-open');
      });
    });

    // Click fuera cierra (solo móvil)
    document.addEventListener('click', (e) => {
      if (!mqMobile.matches) return;
      const inside = e.target.closest('[data-pv-social]');
      if (!inside) closeAll();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  mqMobile.addEventListener('change', () => closeAll());
})();
